import { AlertTriangle, Star_06 } from '@recruit-robin/robin-theme/web-icons';
import { useContext } from 'react';
import { LocalizationContext } from 'shared/legacy/contexts/LocalizationContext/LocalizationContext';
import { ActivateRobinJrDialogType } from './ActivateRobinJrDialog.types';

export const useDialogConfig = (type: ActivateRobinJrDialogType) => {
  const { dictionary } = useContext(LocalizationContext);

  const config = {
    [ActivateRobinJrDialogType.Activate]: {
      title: dictionary.activateRobinJrTitle,
      iconTitle: Star_06,
      description: dictionary.activateRobinJrDescription,
      confirmButtonLabel: dictionary.getStarted,
      footerMessage: dictionary.activateRobinJrTrackProgress,
      footerMessageColor: 'neutral.variant.70',
      footerIcon: null,
    },
    [ActivateRobinJrDialogType.Reactivate]: {
      title: dictionary.reactivateRobinJrTitle,
      iconTitle: Star_06,
      description: dictionary.reactivateRobinJrDescription,
      confirmButtonLabel: dictionary.continue,
      footerMessage: dictionary.changingTheJobWillRestart,
      footerMessageColor: 'tertiary.red.50',
      footerIcon: AlertTriangle,
    },
  };

  return config[type];
};
